/* eslint-disable */
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
// reactstrap components
import Cookies from "js-cookie";
// Routes
import routes from "../routes";
// core components
import AdminNavbar from "../components/Navbars/AdminNavbar";
// import AdminFooter from "../components/Footers/AdminFooter";
import Sidebar from "../components/Sidebar/Sidebar";
import axios from "axios";
import { baseUriUsers, envHost, loginUri } from "../utils/uri";
import { toast, ToastContainer } from "react-toastify";
import NotFound from "../views/404/404";
import {
  getAllAvailableLanguageAction,
  getAllProperties,
  getHeaders,
  getMe,
  getMeAuth,
} from "../utils/store/actions/users.actions";
import { connect } from "react-redux";

Cookies.set("logeed", "true");

type Props = {
  location: {
    pathname: string;
  };
};

// type RouteType = {
//   path: string;
//   name: string;
//   icon: string;
//   component: () => JSX.Element;
//   layout: string;
//   subMenu?: {
//     path: string;
//     name: string;
//     icon: string;
//     component: () => JSX.Element;
//     layout: string;
//   }[];
// }[];

class Admin extends Component<any, any> {
  state = {
    error: false,
    isLoading: false,
  };
  getRoutes = (layoutRoutes: any) => {
    return layoutRoutes.map((prop: any, key: any) => {
      if (prop.layout === "/admin" && !prop.subMenu) {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            component={() => <prop.component />}
            key={key}
          />
        );
      } else if (prop.subMenu) {
        return (
          prop.subMenu !== undefined &&
          prop.subMenu.map((prop: any, key: any) => {
            return (
              <Route
                exact
                path={prop.layout + prop.path}
                component={prop.component}
                key={key}
              />
            );
          })
        );
      }
      return null;
    });
  };

  getBrandText = (path: string) => {
    for (let i = 0; i < routes.length; i += 1) {
      let menu = routes[i];
      if (path.includes(menu.layout + menu.path) && !menu.subMenu) {
        return menu.name;
      }
      if (menu.subMenu) {
        for (let j = 0; j < menu.subMenu.length; j++) {
          let subMenu = menu.subMenu[j];
          if (path === subMenu.layout + subMenu.path) {
            return subMenu.name;
          }
        }
      }
    }
    return "Brand";
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    try {
      await this.props.getMe();
      await this.props.getAllProperties();
      await this.props.getMeAuth();
      await this.props.getAllAvailableLanguageAction();
    } catch (e) {
      console.log(e);
    } finally {
      this.setState({ isLoading: false });
      if (this.props.role.canDoSupervise != undefined && this.props.role.canDoSupervise != "ALL") {
        window.location.href = `${loginUri}${envHost}`;
      }
    }
  }
  render() {
    let { location } = this.props;
    const { pathname } = location;
    setInterval(() => {
      getHeaders();
      axios.get(`${baseUriUsers}/service-user/v1/users/me`).catch((e) => {
        if (e.response && e.response.status === 401) {
          setTimeout(() => {
            Cookies.remove("authToken");
            Cookies.remove("accessToken");
            window.location.reload();
          }, 300);
        } else {
          toast.error("NETWORK ERROR", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    }, 60000);

    return (
      <>
        <Sidebar
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props}
          routes={routes}
          logo={{
            innerLink: "/admin/index",
            // eslint-disable-next-line global-require
            imgAlt: "Logo",
          }}
        />
        <div className="main-content">
          <AdminNavbar
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...this.props}
            brandText={this.getBrandText(pathname)}
          />
          <ToastContainer />
          <Switch>
            {this.getRoutes(routes)}
            {/* <Route exact path="/users/:id" component={User} /> */}
            <Route component={NotFound} />
          </Switch>
          {/* <Container fluid>
            <AdminFooter />
          </Container> */}
        </div>
      </>
    );
  }
}


const mapStateToProps = (state: {
  LocalUser: LocalUserState;
}) => ({
  role: state.LocalUser.role,
});

const mapDispatchToProps = {
  getMe,
  getMeAuth,
  getAllProperties,
  getHeaders,
  getAllAvailableLanguageAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Admin);
